import template1 from './1/component';
import template2 from './2/component';
import template3 from './3/component';
import template4 from './4/component';

const templates = {
	1: template1,
	2: template2,
	3: template3,
	4: template4,
};
export default templates;
export function RichTextVideo(templateId = 1) {
	return templates[templateId]();
}
